var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASUlEQVR42mMYBfjBU0nJMyBMtuaFfHxgDGKTpbmWgwOE4YaQohkrBskR1EwYE3ZJGjGYNi4ASqbN4OWdRQiDXYAHGBODh1FyBwBRUlpqcEUISAAAAABJRU5ErkJggg==";
  export default img;